export class RxStore {
    constructor() {
        this.behaviorSubjectsByKey = new Map();
    }
}
//# sourceMappingURL=rxStore.js.map